
// Global animation intervals
let setIntervalFirst: any;
let setIntervalSecond: any;

/**
 * Applies filter effects to a layer view
 */
export function applyFilter(layerView: any, field: any) {
  let featureFilter = {
    where: `${field}='R' OR ${field}='true'`,
  };

  setIntervalFirst = setInterval(() => {
    layerView.featureEffect = {
      filter: featureFilter,
      includedEffect:
        "invert(70%) saturate(150%) hue-rotate(320deg) drop-shadow(16px 16px 80px red) bloom(200%, 1px, 0.2)",
      excludedLabelsVisible: true,
    };
  }, 600);

  setIntervalSecond = setInterval(() => {
    layerView.featureEffect = {
      filter: featureFilter,
      includedEffect: "grayscale(25%) blur(5px) opacity(55%)",
      excludedLabelsVisible: true,
    };
  }, 500);
}

/**
 * Creates animation effects for the map
 */
export function animationEffect(mapView: any) {
  mapView
    .whenLayerView(window.F_Land_parcelsFlashLight)
    .then((featureLayerView: any) => {
      applyFilter(featureLayerView, "Feature_Ad");
    });
}

/**
 * Clears animation intervals
 */
export function clearAnimationIntervals() {
  if (setIntervalFirst) {
    clearInterval(setIntervalFirst);
    setIntervalFirst = null;
  }
  if (setIntervalSecond) {
    clearInterval(setIntervalSecond);
    setIntervalSecond = null;
  }
}

/**
 * Gets animation state
 */
export function getAnimationState() {
  return {
    setIntervalFirst,
    setIntervalSecond
  };
}
